@if (!isLoading) {
  <div class="container">
    <div class="head">
      <img src="./assets/images/transend-logo-dark.png">
      <h2>Terms of Service</h2>
    </div>
    <!-- Display TOS content if user role is defined -->
    @if (userRole != undefined) {
      <div>
        <app-tos-content></app-tos-content>
      </div>
    }
    <!-- Display error if user role isn't defined -->
    @if (userRole == undefined) {
      <div>
        <p class="error">No user role information available. Please contact an administrator.</p>
      </div>
    }
    <!-- If already accepted, show home button -->
    @if (isTosAccepted) {
      <div>
        <p>You have already accepted the Terms of Service.</p>
        <a [routerLink]="['/']">Go to Home</a>
      </div>
    }
    <!-- If not accepted, show accept button -->
    @if (!isTosAccepted) {
      <div class="controls">
        <mat-checkbox [(ngModel)]="isCheckboxChecked" color="primary">
          I have read and agree to the Terms of Service
        </mat-checkbox>
        <button mat-flat-button color="primary" [disabled]="!isCheckboxChecked" (click)="onAccept()">Accept</button>
        @if (error !== '') {
          <p>{{ error }}</p>
        }
      </div>
    }
  </div>
} @else {
  <div class="loading">
    <mat-spinner></mat-spinner>
  </div>
}

